import type { AppRouteModule, AppRouteRecordRaw } from '/@/router/types'

import { PAGE_NOT_FOUND_ROUTE, REDIRECT_ROUTE } from '/@/router/routes/basic'

// import { mainOutRoutes } from './mainOut'
import { PageEnum } from '/@/enums/pageEnum'
import { t } from '/@/hooks/web/useI18n'
import { isProdMode } from '@/utils/env'

const modules = import.meta.glob('./modules/**/*.ts', { eager: true })

const routeModuleList: AppRouteModule[] = []

// 加入到路由集合中
Object.keys(modules).forEach((key) => {
    const mod = (modules as Recordable)[key].default || {}
    const modList = Array.isArray(mod) ? [...mod] : [mod]

    routeModuleList.push(...modList)
})

let afterSortRouteList = [...routeModuleList]

if (isProdMode()) {
    afterSortRouteList = routeModuleList
}

// console.log('afterSortRouteList', afterSortRouteList)
export const asyncRoutes = [PAGE_NOT_FOUND_ROUTE, ...afterSortRouteList]

// 根路由
export const RootRoute: AppRouteRecordRaw = {
    path: '/',
    name: 'Root',
    redirect: PageEnum.BASE_HOME,
    meta: {
        title: 'Root',
    },
}

export const LoginRoute: AppRouteRecordRaw = {
    path: '/login',
    name: 'Login',
    component: () => import('/@/views/sys/login/Login.vue'),
    meta: {
        title: t('routes.basic.login'),
    },
}

// Basic routing without permission
// 未经许可的基本路由 mainOutRoutes

export const basicRoutes = [LoginRoute, RootRoute, REDIRECT_ROUTE, PAGE_NOT_FOUND_ROUTE]
